if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.idInput = this.form.querySelector("[name=id]");
        this.idInput.addEventListener(
          "change",
          this.removeButtonActive.bind(this),
        );
        if (this.dataset.formId) {
          this.formID = this.dataset.formId;
          this.quantitiyInput = document.querySelector(
            `.quantity__input[form=${this.formID}]`,
          );
          if (this.quantitiyInput) {
            this.quantitiyInput.addEventListener(
              "change",
              this.removeButtonActive.bind(this),
            );
          }
        }

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      renderCart() {
        fetch(window.location.href, { cache: "no-store" })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );

            const newCartDrawer = html.querySelector("cart-drawer");
            const cartDrawer = document.querySelector("cart-drawer");
            if (newCartDrawer && cartDrawer) {
              cartDrawer.innerHTML = newCartDrawer.innerHTML;
              // Cart drawer will no longer auto-open after add to cart
              document
                .querySelector("#CartDrawer-Overlay")
                .addEventListener("click", () => {
                  cartDrawer.classList.remove("active");
                });
            }

            const newCartBubble = html.querySelector(".cart-count-bubble");
            const cartBubble = document.querySelector(".cart-count-bubble");
            if (newCartBubble && cartBubble) {
              cartBubble.innerHTML = newCartBubble.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // Re-check for cart drawer at submit time (it may not have existed when constructor ran)
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden",
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // Explicitly get quantity from the card's quantity input
        const cardWrapper = this.closest(".card-wrapper");
        if (cardWrapper) {
          const qtyInput = cardWrapper.querySelector('input[name="quantity"]');
          if (qtyInput) {
            formData.set("quantity", qtyInput.value);
            console.log("Setting quantity from card input:", qtyInput.value);
          }
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        formData.forEach((value, key) => {
          console.log(`${key}: ${value}`);
        });

        const quantity = parseInt(formData.get("quantity"));
        const inventory_quantity = parseInt(formData.get("inventory_quantity"));
        const title = formData.get("title");
        if (inventory_quantity < quantity && inventory_quantity > 0) {
          // Change the quantity to the available quantity
          formData.set("quantity", inventory_quantity);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log("response", response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.renderCart();
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.disabled = true;
              this.submitButton.setAttribute("aria-disabled", true);
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden",
            );

            if (inventory_quantity < quantity && inventory_quantity > 0) {
              this.showErrorPopup("", { quantity, inventory_quantity, title });
            }

            this.submitButton.classList.add("active");
            let submitButton = this.submitButton;

            setTimeout(function () {
              submitButton.classList.remove("active");
            }, 2000);
          });
      }
      removeButtonActive() {
        this.submitButton.classList.remove("active");
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        if (errorMessage) {
          this.showErrorPopup(errorMessage);
        }
      }

      showErrorPopup(message, updateQuantity) {
        let popupHTML;
        if (updateQuantity) {
          const { quantity, inventory_quantity, title } = updateQuantity;
          popupHTML = `<div class="order_again_popup_wrapper body">
            <div class="order_again_popup_background">

            </div>
            <div class="order_again_popup">
              <p class="order_again_popup_title h3">Produktmenge nicht mehr verfügbar</p>
              <p class="order_again_popup_text">Leider ist folgendes Produkt nicht mehr in der von Ihnen gewünschten Menge verfügbar:</p>
                <div class="order_again_popup--scrollable">
                  <div class="unavailable_products_row">
                    <p>${title}</p>
                    <div class="unavailable_products_quantity">
                    <del>${quantity}</del>
                      <div class="unavailable_products_arrow">
                        <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
                        </svg>
                      </div>
                    <p>${inventory_quantity}</p>
                    </div>
                  </div>
                </div>

              <div class="button button--primary close">OK</div>
            </div>
          </div>`;
        } else {
          const regex = /\bAlle (\d+)\b/;
          const formattedMessage = message.replace(
            regex,
            "Alle <strong>$1</strong>",
          );

          popupHTML = `<div class="order_again_popup_wrapper body">
            <div class="order_again_popup_background">

            </div>
            <div class="order_again_popup">
              <p class="order_again_popup_title h3">Produktmenge nicht mehr verfügbar</p>
              <p class="order_again_popup_text">${formattedMessage || "Leider ist zur Zeit dieses Produkt ausverkauft."}</p>
              <div class="button button--primary close">OK</div>
            </div>
          </div>`;
        }
        const fragment = document
          .createRange()
          .createContextualFragment(popupHTML);
        document.body.appendChild(fragment);
        const errorPopup = document.body.querySelector(
          ".order_again_popup_wrapper.body",
        );
        errorPopup.style.display = "flex";
        errorPopup.style.zIndex = "9999";
        errorPopup
          .querySelector(".button.button--primary.close")
          .addEventListener("click", () => {
            errorPopup.remove();
          });
        const background = errorPopup.querySelector(
          ".order_again_popup_background",
        );
        background.style.zIndex = "-1";
        background.addEventListener("click", () => {
          errorPopup.remove();
        });
      }
    },
  );
}
